import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { Provider } from 'react-redux'
import store from './app/dataStore/presenter-store'
import Access from './app/pages/Access'
import Preview from './app/pages/Preview'
import Presenter from './app/pages/Presenter'
import End from './app/pages/End'
import MessageCenter from './app/pages/MessageCenter'
import styles from '@bt-react/styles'
import axiosSetup from './app/setup/axios'
import setGlobalEvents from './app/setup/events'
import setupActions from './app/dataStore/actions/setup'
import ControlCentre from './app/pages/ControlCentre'

axiosSetup()

//To avoid a race condition with the connected and disconnected events when a user rejoins the room while still in the room from another tab/window.
//We kick them out from the room before they attempt to join from the new tab/window
const storageKeyForUniqueEntry = `talks-present-join-${document.location.pathname.split('/').pop()}`
window.localStorage.setItem(storageKeyForUniqueEntry, Date.now().toString())
window.addEventListener('storage', ({ key }) => {
  if (key === storageKeyForUniqueEntry) {
    window.location.href = '/presenting'
  }
})
setGlobalEvents(store)
setupActions.setGigOptions()(store.dispatch)

const container = document.getElementById('root')
const root = createRoot(container)
root.render(<div className={`${styles['bootstrap-container']}`}>
<Router basename='/talks' >
  <Provider store={store}>
    <Switch>
      <Route path="/messageCenter/:messageCode?"><MessageCenter /></Route>
      <Route path="/end/:roomname?"><End /></Route>
      <Route path="/present/:roomname?"><Presenter /></Route>
      <Route path="/preview/:roomname?"><Preview /></Route>
      <Route path="/control-centre/:roomname?">{<ControlCentre />}</Route>
      <Route path="/:roomname?"><Access /></Route>
    </Switch>
  </Provider>
</Router>
</div>)
